/**
 * Course authoring of words and games (CourseVocabulary, CourseGames): import modes and line
 * errors of the word paste, the arcade readiness checklist, editing saved story steps and
 * puzzles, the puzzle paste and AI generation. Uzbek is the source language.
 */
const gameAuthoring = {
  uz: {
    addLesson: "Dars qo'shish",
    words: {
      modeLabel: 'Import turi',
      modeAppend: "Qo'shish",
      modeAppendHint: "Darsdagi so'zlar qoladi. Yangi so'zlar oxiriga qo'shiladi, bor so'z esa yangilanadi.",
      modeReplace: 'Almashtirish',
      modeReplaceHint: "Darsning ro'yxati aynan shu so'zlar bo'ladi. Ro'yxatda yo'q so'zlar darsdan o'chiriladi.",
      hint: "Har bir qatorga bitta so'z: ruscha, o'zbekcha, inglizcha (ixtiyoriy), ruscha misol gap (ixtiyoriy). Ustunlarni tab, «;», « - » yoki vergul bilan ajrating.",
      formatHint: "ruscha - o'zbekcha - inglizcha - misol",
      placeholder: "дом - uy - house - Это мой дом.\nкнига\tkitob\tbook\nкот; mushuk",
      colExample: 'Misol (ruscha)',
      colStatus: 'Holati',
      statusNew: 'Yangi',
      statusUpdate: 'Yangilanadi',
      addedCount: "{count} ta yangi so'z",
      addedCount_plural: "{count} ta yangi so'z",
      updatedCount: "{count} ta so'z yangilanadi",
      updatedCount_plural: "{count} ta so'z yangilanadi",
      keptCount: "{count} ta so'z o'zgarmaydi",
      keptCount_plural: "{count} ta so'z o'zgarmaydi",
      removedCount: "{count} ta so'z darsdan o'chiriladi",
      removedCount_plural: "{count} ta so'z darsdan o'chiriladi",
      errorsTitle: '{count} ta qator import qilinmaydi',
      errorsTitle_plural: '{count} ta qator import qilinmaydi',
      lineLabel: '{line}-qator',
      reason: {
        missingTranslation: "ruscha so'z va o'zbekcha tarjima kerak",
        tooLong: '«{column}» juda uzun',
        duplicate: "bu so'z {firstLine}-qatorda bor",
      },
      column: {
        term: 'Ruscha',
        translationUz: "O'zbekcha",
        translationEn: 'Inglizcha',
        exampleRu: 'Misol',
      },
      appendAction: "{count} ta so'zni qo'shish",
      appendAction_plural: "{count} ta so'zni qo'shish",
      nothingNew: "Yangi so'z yo'q — ro'yxatdagi barcha so'zlar darsda bor va yangilanadi.",
      saveAction: 'Saqlash',
      confirmReplaceTitle: "So'zlar ro'yxati almashtirilsinmi?",
      confirmReplaceDesc: "Ro'yxatda yo'q {count} ta so'z darsdan o'chiriladi.",
      confirmReplaceDesc_plural: "Ro'yxatda yo'q {count} ta so'z darsdan o'chiriladi.",
      confirmReplace: 'Almashtirish',
      tooMany: "Bitta darsda 500 tadan ortiq so'z bo'lishi mumkin emas ({count} ta bo'lib qoladi).",
      importedSummary: "{added} ta qo'shildi, {updated} ta yangilandi",
      reloadFailed: "So'zlarni qayta o'qib bo'lmadi. Keyinroq urinib ko'ring.",
      englishOptional: 'Inglizcha (ixtiyoriy)',
    },
    games: {
      autoExplain:
        "So'z o'yinlari — Rasmli viktorina, Xotira o'yini, Gap tuzish va So'z sprinti — darsdagi so'zlardan avtomatik tuziladi. Ular uchun o'yin yaratish shart emas: darsga so'zlar, rasmlar va misol gaplar qo'shing.",
      readinessTitle: "So'z o'yinlariga tayyorlik",
      readinessWords: "{count} ta so'z",
      readinessWords_plural: "{count} ta so'z",
      readinessPictures: 'rasmli: {count}',
      readinessSentences: 'misol gaplar: {count}',
      ready: 'Tayyor',
      needWords: "yana {count} ta so'z kerak",
      needWords_plural: "yana {count} ta so'z kerak",
      needPictures: 'yana {count} ta rasm kerak',
      needPictures_plural: 'yana {count} ta rasm kerak',
      needSentences: "yana {count} ta misol gap kerak (3–10 so'zli, ruscha)",
      needSentences_plural: "yana {count} ta misol gap kerak (3–10 so'zli, ruscha)",
      longSentences: "{count} ta misol gap 10 so'zdan uzun — Gap tuzish ularni olmaydi",
      longSentences_plural: "{count} ta misol gap 10 so'zdan uzun — Gap tuzish ularni olmaydi",
      memoryPictureMode: "8 ta rasm bo'lsa, Xotira o'yini rasm bilan o'ynaladi",
      openWords: "So'zlarni ochish",
      readinessFailed: "So'z o'yinlari tayyorligini yuklab bo'lmadi.",
      lessonLoadFailed: "Bu darsning o'yinlarini yuklab bo'lmadi.",
      lessonsLoading: 'Darslar yuklanmoqda…',
      storyHelp:
        "Hikoya qadamlardan iborat. O'quvchi qadam matnini o'qiydi va tanlovlardan birini bosadi — tanlov uni keyingi qadamga olib boradi. «Hikoya oxiri» qadamida o'yin tugaydi.",
      stepNumber: '{n}-qadam',
      noStart: "Birinchi qadam belgilanmagan — o'quvchi o'yinni boshlay olmaydi.",
      deadEnd: "Bu qadamdan keyin tanlov yo'q — o'quvchi shu yerda qolib ketadi.",
      endingNote: 'Hikoya shu yerda tugaydi.',
      makeStart: 'Birinchi qadam qilish',
      edit: 'Tahrirlash',
      save: 'Saqlash',
      saved: 'Saqlandi',
      saveFailed: "Saqlab bo'lmadi",
      deleted: "O'chirildi",
      deleteFailed: "O'chirib bo'lmadi",
      contentLoadFailed: "O'yinning saqlangan qismlarini yuklab bo'lmadi.",
      deleteStepTitle: "Qadam o'chirilsinmi?",
      deleteStepDesc: "Unga olib boradigan va undan chiqadigan {count} ta tanlov ham o'chiriladi.",
      deleteStepDesc_plural: "Unga olib boradigan va undan chiqadigan {count} ta tanlov ham o'chiriladi.",
      deleteStepStart: "Bu birinchi qadam — o'rniga eng oldingi qadam birinchi bo'ladi.",
      deleteChoiceTitle: "Tanlov o'chirilsinmi?",
      deletePuzzleTitle: "Topishmoq o'chirilsinmi?",
      deletePuzzleDesc: "O'quvchilarning bu topishmoqqa bergan javoblari ham o'chiriladi.",
      choiceTarget: '→ {step}',
      missingTarget: "(o'chirilgan qadam)",
      errorCode: {
        START_NODE_REQUIRED: "Hikoyada doim bitta birinchi qadam bo'ladi. Boshqa qadamni birinchi qiling.",
        TERMINAL_HAS_CHOICES: "Hikoya oxirida tanlov bo'lmaydi. Avval bu qadamning tanlovlarini o'chiring.",
      },
      bulkPuzzles: "Ro'yxatdan qo'shish",
      bulkTitle: "Topishmoqlarni ro'yxatdan qo'shish",
      bulkHint: "Har bir qatorga bitta topishmoq: savol = javob. Maslahatlarni «|» dan keyin yozing, bir nechta bo'lsa har birini «|» bilan ajrating.",
      bulkPlaceholder: "«Дом» o'zbekcha nima? = uy | Bino\nСтолица России? = Москва | Rossiyada | M harfi bilan boshlanadi",
      bulkPreview: "Ko'rib chiqish",
      bulkBack: 'Tahrirga qaytish',
      bulkReady: "{count} ta topishmoq qo'shishga tayyor",
      bulkReady_plural: "{count} ta topishmoq qo'shishga tayyor",
      bulkAction: "{count} ta topishmoq qo'shish",
      bulkAction_plural: "{count} ta topishmoq qo'shish",
      bulkAdded: "{count} ta topishmoq qo'shildi",
      bulkAdded_plural: "{count} ta topishmoq qo'shildi",
      bulkFailed: "Topishmoqlarni qo'shib bo'lmadi",
      bulkEmpty: "Hozircha qo'shadigan narsa yo'q — yuqoriga ro'yxatni joylashtiring.",
      bulkTooMany: "Bir martada ko'pi bilan 100 ta topishmoq qo'shiladi.",
      colQuestion: 'Savol',
      colAnswer: 'Javob',
      colHints: 'Maslahatlar',
      puzzleReason: {
        missingEquals: "«=» belgisi yo'q (savol = javob)",
        missingQuestion: "savol yo'q",
        missingAnswer: "javob yo'q",
        tooLong: 'juda uzun',
      },
      aiButton: 'AI bilan yaratish',
      aiTitle: "AI bilan o'yin yaratish",
      aiIntro: "Mavzuni yozing — AI hikoya yoki topishmoqlar tayyorlaydi. Natija o'quvchilarga darhol ko'rinmaydi: avval siz tekshirasiz.",
      aiTopicLabel: 'Mavzu',
      aiTopicPlaceholder: "Masalan: bozorda xarid qilish, oila a'zolari, ranglar",
      aiTopicCount: '{count}/300',
      aiStart: 'Yaratish',
      aiStarted: "AI o'yin tayyorlashni boshladi",
      aiPending: 'AI tayyorlamoqda…',
      aiPendingDesc: "Odatda 1–2 daqiqa. Sahifani yopsangiz ham ish to'xtamaydi — natija shu darsda paydo bo'ladi.",
      aiCheck: 'Tekshirish',
      aiReady: "AI o'yinni tayyorladi — tekshirib chiqing",
      aiStillWorking: "AI hali ishlayapti. Birozdan keyin «Tekshirish»ni bosing.",
      aiFailed: "AI o'yin tayyorlay olmadi. Mavzuni o'zgartirib qayta urinib ko'ring.",
      aiUnavailable: "AI hozir ishlamayapti. Keyinroq urinib ko'ring yoki o'yinni qo'lda yarating.",
      aiStartFailed: "AI bilan yaratishni boshlab bo'lmadi",
      aiRolesNote: 'AI bilan yaratish mentorlar va adminlar uchun.',
      aiBadge: 'AI',
      aiReview:
        "Bu o'yinni AI yaratdi va u o'quvchilardan yashirin. Qadamlar yoki topishmoqlarni tekshiring, kerak bo'lsa tuzating, keyin «O'quvchilarga ochish»ni bosing.",
      hiddenBadge: "O'quvchilardan yashirin",
      visibleBadge: "O'quvchilarga ko'rinadi",
      loadFailedShort: 'Yuklanmadi',
      publish: "O'quvchilarga ochish",
      unpublish: 'Yashirish',
      published: "O'yin o'quvchilarga ochildi",
      unpublished: "O'yin o'quvchilardan yashirildi",
      visibilityFailed: "O'yin holatini o'zgartirib bo'lmadi",
    },
  },
  ru: {
    addLesson: 'Добавить урок',
    words: {
      modeLabel: 'Способ импорта',
      modeAppend: 'Добавить',
      modeAppendHint: 'Слова урока остаются. Новые добавляются в конец, а уже существующие обновляются.',
      modeReplace: 'Заменить',
      modeReplaceHint: 'Список урока станет ровно этим списком. Слова, которых в нём нет, будут удалены из урока.',
      hint: 'Одно слово в строке: русский, узбекский, английский (необязательно), пример на русском (необязательно). Столбцы разделяйте табуляцией, «;», « - » или запятой.',
      formatHint: 'русский - узбекский - английский - пример',
      placeholder: "дом - uy - house - Это мой дом.\nкнига\tkitob\tbook\nкот; mushuk",
      colExample: 'Пример (рус.)',
      colStatus: 'Статус',
      statusNew: 'Новое',
      statusUpdate: 'Обновится',
      addedCount: '{count} новое слово',
      addedCount_few: '{count} новых слова',
      addedCount_plural: '{count} новых слов',
      updatedCount: '{count} слово обновится',
      updatedCount_few: '{count} слова обновятся',
      updatedCount_plural: '{count} слов обновятся',
      keptCount: '{count} слово без изменений',
      keptCount_few: '{count} слова без изменений',
      keptCount_plural: '{count} слов без изменений',
      removedCount: '{count} слово будет удалено из урока',
      removedCount_few: '{count} слова будут удалены из урока',
      removedCount_plural: '{count} слов будут удалены из урока',
      errorsTitle: '{count} строка не будет импортирована',
      errorsTitle_few: '{count} строки не будут импортированы',
      errorsTitle_plural: '{count} строк не будут импортированы',
      lineLabel: 'Строка {line}',
      reason: {
        missingTranslation: 'нужны русское слово и узбекский перевод',
        tooLong: '«{column}» слишком длинный',
        duplicate: 'это слово уже есть в строке {firstLine}',
      },
      column: {
        term: 'Русский',
        translationUz: 'Узбекский',
        translationEn: 'Английский',
        exampleRu: 'Пример',
      },
      appendAction: 'Добавить {count} слово',
      appendAction_few: 'Добавить {count} слова',
      appendAction_plural: 'Добавить {count} слов',
      nothingNew: 'Новых слов нет — все слова списка уже есть в уроке и будут обновлены.',
      saveAction: 'Сохранить',
      confirmReplaceTitle: 'Заменить список слов?',
      confirmReplaceDesc: '{count} слово, которого нет в списке, будет удалено из урока.',
      confirmReplaceDesc_few: '{count} слова, которых нет в списке, будут удалены из урока.',
      confirmReplaceDesc_plural: '{count} слов, которых нет в списке, будут удалены из урока.',
      confirmReplace: 'Заменить',
      tooMany: 'В уроке может быть не больше 500 слов (получится {count}).',
      importedSummary: 'Добавлено: {added}, обновлено: {updated}',
      reloadFailed: 'Не удалось перечитать слова. Попробуйте позже.',
      englishOptional: 'Английский (необязательно)',
    },
    games: {
      autoExplain:
        'Словесные игры — Картинка-викторина, Найди пару, Собери предложение и Гонка слов — строятся из слов урока автоматически. Создавать их не нужно: добавьте в урок слова, картинки и примеры.',
      readinessTitle: 'Готовность словесных игр',
      readinessWords: '{count} слово',
      readinessWords_few: '{count} слова',
      readinessWords_plural: '{count} слов',
      readinessPictures: 'с картинкой: {count}',
      readinessSentences: 'примеров: {count}',
      ready: 'Готово',
      needWords: 'нужно ещё {count} слово',
      needWords_few: 'нужно ещё {count} слова',
      needWords_plural: 'нужно ещё {count} слов',
      needPictures: 'нужна ещё {count} картинка',
      needPictures_few: 'нужны ещё {count} картинки',
      needPictures_plural: 'нужно ещё {count} картинок',
      needSentences: 'нужен ещё {count} пример (3–10 слов, по-русски)',
      needSentences_few: 'нужны ещё {count} примера (3–10 слов, по-русски)',
      needSentences_plural: 'нужно ещё {count} примеров (3–10 слов, по-русски)',
      longSentences: '{count} пример длиннее 10 слов — «Собери предложение» его не берёт',
      longSentences_few: '{count} примера длиннее 10 слов — «Собери предложение» их не берёт',
      longSentences_plural: '{count} примеров длиннее 10 слов — «Собери предложение» их не берёт',
      memoryPictureMode: 'С 8 картинками «Найди пару» играется с картинками',
      openWords: 'Открыть слова',
      readinessFailed: 'Не удалось загрузить готовность словесных игр.',
      lessonLoadFailed: 'Не удалось загрузить игры этого урока.',
      lessonsLoading: 'Загружаем уроки…',
      storyHelp:
        'История состоит из шагов. Ученик читает текст шага и нажимает один из вариантов — вариант ведёт к следующему шагу. На шаге «Конец истории» игра заканчивается.',
      stepNumber: 'Шаг {n}',
      noStart: 'Не выбран первый шаг — ученик не сможет начать игру.',
      deadEnd: 'У этого шага нет вариантов — ученик здесь застрянет.',
      endingNote: 'Здесь история заканчивается.',
      makeStart: 'Сделать первым шагом',
      edit: 'Изменить',
      save: 'Сохранить',
      saved: 'Сохранено',
      saveFailed: 'Не удалось сохранить',
      deleted: 'Удалено',
      deleteFailed: 'Не удалось удалить',
      contentLoadFailed: 'Не удалось загрузить сохранённое содержимое игры.',
      deleteStepTitle: 'Удалить шаг?',
      deleteStepDesc: 'Также будет удалён {count} вариант, ведущий к нему или из него.',
      deleteStepDesc_few: 'Также будут удалены {count} варианта, ведущие к нему или из него.',
      deleteStepDesc_plural: 'Также будут удалены {count} вариантов, ведущих к нему или из него.',
      deleteStepStart: 'Это первый шаг — первым станет самый ранний из оставшихся.',
      deleteChoiceTitle: 'Удалить вариант?',
      deletePuzzleTitle: 'Удалить загадку?',
      deletePuzzleDesc: 'Ответы учеников на эту загадку тоже будут удалены.',
      choiceTarget: '→ {step}',
      missingTarget: '(удалённый шаг)',
      errorCode: {
        START_NODE_REQUIRED: 'В истории всегда есть один первый шаг. Сделайте первым другой шаг.',
        TERMINAL_HAS_CHOICES: 'У конца истории не бывает вариантов. Сначала удалите варианты этого шага.',
      },
      bulkPuzzles: 'Добавить списком',
      bulkTitle: 'Добавить загадки списком',
      bulkHint: 'Одна загадка в строке: вопрос = ответ. Подсказки пишите после «|», несколько — через «|».',
      bulkPlaceholder: "«Дом» o'zbekcha nima? = uy | Bino\nСтолица России? = Москва | Rossiyada | M harfi bilan boshlanadi",
      bulkPreview: 'Просмотр',
      bulkBack: 'Вернуться к редактированию',
      bulkReady: 'Готова к добавлению {count} загадка',
      bulkReady_few: 'Готовы к добавлению {count} загадки',
      bulkReady_plural: 'Готово к добавлению {count} загадок',
      bulkAction: 'Добавить {count} загадку',
      bulkAction_few: 'Добавить {count} загадки',
      bulkAction_plural: 'Добавить {count} загадок',
      bulkAdded: 'Добавлена {count} загадка',
      bulkAdded_few: 'Добавлены {count} загадки',
      bulkAdded_plural: 'Добавлено {count} загадок',
      bulkFailed: 'Не удалось добавить загадки',
      bulkEmpty: 'Пока нечего добавлять — вставьте список выше.',
      bulkTooMany: 'За один раз можно добавить не больше 100 загадок.',
      colQuestion: 'Вопрос',
      colAnswer: 'Ответ',
      colHints: 'Подсказки',
      puzzleReason: {
        missingEquals: 'нет знака «=» (вопрос = ответ)',
        missingQuestion: 'нет вопроса',
        missingAnswer: 'нет ответа',
        tooLong: 'слишком длинно',
      },
      aiButton: 'Создать с ИИ',
      aiTitle: 'Создать игру с ИИ',
      aiIntro: 'Напишите тему — ИИ подготовит историю или загадки. Ученики не увидят результат сразу: сначала его проверите вы.',
      aiTopicLabel: 'Тема',
      aiTopicPlaceholder: 'Например: покупки на рынке, члены семьи, цвета',
      aiTopicCount: '{count}/300',
      aiStart: 'Создать',
      aiStarted: 'ИИ начал готовить игру',
      aiPending: 'ИИ готовит…',
      aiPendingDesc: 'Обычно 1–2 минуты. Можно закрыть страницу — результат появится в этом уроке.',
      aiCheck: 'Проверить',
      aiReady: 'ИИ подготовил игру — проверьте её',
      aiStillWorking: 'ИИ ещё работает. Нажмите «Проверить» чуть позже.',
      aiFailed: 'ИИ не смог подготовить игру. Измените тему и попробуйте снова.',
      aiUnavailable: 'ИИ сейчас недоступен. Попробуйте позже или создайте игру вручную.',
      aiStartFailed: 'Не удалось запустить создание с ИИ',
      aiRolesNote: 'Создание с ИИ доступно менторам и администраторам.',
      aiBadge: 'ИИ',
      aiReview:
        'Эту игру создал ИИ, и она скрыта от учеников. Проверьте шаги или загадки, при необходимости исправьте, затем нажмите «Открыть ученикам».',
      hiddenBadge: 'Скрыта от учеников',
      visibleBadge: 'Видна ученикам',
      loadFailedShort: 'Не загрузилось',
      publish: 'Открыть ученикам',
      unpublish: 'Скрыть',
      published: 'Игра открыта ученикам',
      unpublished: 'Игра скрыта от учеников',
      visibilityFailed: 'Не удалось изменить видимость игры',
    },
  },
  en: {
    addLesson: 'Add a lesson',
    words: {
      modeLabel: 'Import mode',
      modeAppend: 'Add',
      modeAppendHint: "The lesson's words stay. New words go to the end; words the lesson already has are updated.",
      modeReplace: 'Replace',
      modeReplaceHint: "The lesson's list becomes exactly these words. Words not in it are removed from the lesson.",
      hint: 'One word per line: Russian, Uzbek, English (optional), Russian example (optional). Separate columns with a tab, «;», « - » or a comma.',
      formatHint: 'russian - uzbek - english - example',
      placeholder: "дом - uy - house - Это мой дом.\nкнига\tkitob\tbook\nкот; mushuk",
      colExample: 'Example (Russian)',
      colStatus: 'Status',
      statusNew: 'New',
      statusUpdate: 'Updates',
      addedCount: '{count} new word',
      addedCount_plural: '{count} new words',
      updatedCount: '{count} word updates',
      updatedCount_plural: '{count} words update',
      keptCount: '{count} word unchanged',
      keptCount_plural: '{count} words unchanged',
      removedCount: '{count} word will be removed from the lesson',
      removedCount_plural: '{count} words will be removed from the lesson',
      errorsTitle: "{count} line won't be imported",
      errorsTitle_plural: "{count} lines won't be imported",
      lineLabel: 'Line {line}',
      reason: {
        missingTranslation: 'needs a Russian word and an Uzbek translation',
        tooLong: '“{column}” is too long',
        duplicate: 'this word is already on line {firstLine}',
      },
      column: {
        term: 'Russian',
        translationUz: 'Uzbek',
        translationEn: 'English',
        exampleRu: 'Example',
      },
      appendAction: 'Add {count} word',
      appendAction_plural: 'Add {count} words',
      nothingNew: 'No new words — every word in the list is already in the lesson and will be updated.',
      saveAction: 'Save',
      confirmReplaceTitle: 'Replace the word list?',
      confirmReplaceDesc: '{count} word not in the list will be removed from the lesson.',
      confirmReplaceDesc_plural: '{count} words not in the list will be removed from the lesson.',
      confirmReplace: 'Replace',
      tooMany: 'A lesson can hold at most 500 words (this would make {count}).',
      importedSummary: '{added} added, {updated} updated',
      reloadFailed: "Couldn't reload the words. Try again later.",
      englishOptional: 'English (optional)',
    },
    games: {
      autoExplain:
        "Word games — Picture quiz, Memory match, Sentence builder and Word sprint — are built automatically from the lesson's words. There is nothing to create for them: add words, pictures and example sentences to the lesson.",
      readinessTitle: 'Word game readiness',
      readinessWords: '{count} word',
      readinessWords_plural: '{count} words',
      readinessPictures: 'with a picture: {count}',
      readinessSentences: 'example sentences: {count}',
      ready: 'Ready',
      needWords: 'needs {count} more word',
      needWords_plural: 'needs {count} more words',
      needPictures: 'needs {count} more picture',
      needPictures_plural: 'needs {count} more pictures',
      needSentences: 'needs {count} more example sentence (3–10 Russian words)',
      needSentences_plural: 'needs {count} more example sentences (3–10 Russian words)',
      longSentences: '{count} example is longer than 10 words — Sentence builder skips it',
      longSentences_plural: '{count} examples are longer than 10 words — Sentence builder skips them',
      memoryPictureMode: 'With 8 pictures, Memory match plays with pictures',
      openWords: 'Open the words',
      readinessFailed: "Couldn't load word game readiness.",
      lessonLoadFailed: "Couldn't load this lesson's games.",
      lessonsLoading: 'Loading lessons…',
      storyHelp:
        'A story is made of steps. The student reads a step and picks one of its choices — the choice leads to the next step. The game ends on a “Story ending” step.',
      stepNumber: 'Step {n}',
      noStart: 'No first step is set — students cannot start the game.',
      deadEnd: 'This step has no choices — students get stuck here.',
      endingNote: 'The story ends here.',
      makeStart: 'Make it the first step',
      edit: 'Edit',
      save: 'Save',
      saved: 'Saved',
      saveFailed: "Couldn't save",
      deleted: 'Deleted',
      deleteFailed: "Couldn't delete",
      contentLoadFailed: "Couldn't load the game's saved content.",
      deleteStepTitle: 'Delete this step?',
      deleteStepDesc: '{count} choice leading to or from it is deleted too.',
      deleteStepDesc_plural: '{count} choices leading to or from it are deleted too.',
      deleteStepStart: 'This is the first step — the earliest remaining step becomes the first.',
      deleteChoiceTitle: 'Delete this choice?',
      deletePuzzleTitle: 'Delete this puzzle?',
      deletePuzzleDesc: "Students' answers to this puzzle are deleted too.",
      choiceTarget: '→ {step}',
      missingTarget: '(deleted step)',
      errorCode: {
        START_NODE_REQUIRED: 'A story always has one first step. Make another step the first instead.',
        TERMINAL_HAS_CHOICES: 'A story ending has no choices. Delete this step’s choices first.',
      },
      bulkPuzzles: 'Add from a list',
      bulkTitle: 'Add puzzles from a list',
      bulkHint: 'One puzzle per line: question = answer. Put hints after “|”, several separated by “|”.',
      bulkPlaceholder: "«Дом» o'zbekcha nima? = uy | Bino\nСтолица России? = Москва | Rossiyada | M harfi bilan boshlanadi",
      bulkPreview: 'Preview',
      bulkBack: 'Back to editing',
      bulkReady: '{count} puzzle ready to add',
      bulkReady_plural: '{count} puzzles ready to add',
      bulkAction: 'Add {count} puzzle',
      bulkAction_plural: 'Add {count} puzzles',
      bulkAdded: 'Added {count} puzzle',
      bulkAdded_plural: 'Added {count} puzzles',
      bulkFailed: "Couldn't add the puzzles",
      bulkEmpty: 'Nothing to add yet — paste your list above.',
      bulkTooMany: 'At most 100 puzzles can be added at once.',
      colQuestion: 'Question',
      colAnswer: 'Answer',
      colHints: 'Hints',
      puzzleReason: {
        missingEquals: 'no “=” (question = answer)',
        missingQuestion: 'no question',
        missingAnswer: 'no answer',
        tooLong: 'too long',
      },
      aiButton: 'Create with AI',
      aiTitle: 'Create a game with AI',
      aiIntro: 'Write a topic — AI prepares a story or puzzles. Students do not see the result right away: you review it first.',
      aiTopicLabel: 'Topic',
      aiTopicPlaceholder: 'For example: shopping at the market, family members, colours',
      aiTopicCount: '{count}/300',
      aiStart: 'Create',
      aiStarted: 'AI started preparing the game',
      aiPending: 'AI is preparing…',
      aiPendingDesc: 'Usually 1–2 minutes. You can close the page — the result appears in this lesson.',
      aiCheck: 'Check',
      aiReady: 'AI prepared the game — review it',
      aiStillWorking: 'AI is still working. Press “Check” a little later.',
      aiFailed: "AI couldn't prepare the game. Change the topic and try again.",
      aiUnavailable: 'AI is unavailable right now. Try later or create the game by hand.',
      aiStartFailed: "Couldn't start creating with AI",
      aiRolesNote: 'Creating with AI is open to mentors and admins.',
      aiBadge: 'AI',
      aiReview:
        'AI made this game and it is hidden from students. Check the steps or puzzles, fix what needs fixing, then press “Show to students”.',
      hiddenBadge: 'Hidden from students',
      visibleBadge: 'Visible to students',
      loadFailedShort: "Didn't load",
      publish: 'Show to students',
      unpublish: 'Hide',
      published: 'The game is now visible to students',
      unpublished: 'The game is hidden from students',
      visibilityFailed: "Couldn't change the game's visibility",
    },
  },
};

export default gameAuthoring;
